const exp = /\{\{\s*(.*?)\s*\}\}/g;

const stache = (template, data = {}) =>
  template.replace(exp, (match, submatch) => data[submatch] || '');

export default stache;



// WEBPACK FOOTER //
// ./styleguide/src/assets/lib/stache.js